export function numberToCurrency(x) {
  return x.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}
